import { render, staticRenderFns } from "./CoworkerIcons.vue?vue&type=template&id=ef6535d4&scoped=true"
import script from "./CoworkerIcons.vue?vue&type=script&lang=js"
export * from "./CoworkerIcons.vue?vue&type=script&lang=js"
import style0 from "./CoworkerIcons.vue?vue&type=style&index=0&id=ef6535d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6535d4",
  null
  
)

export default component.exports